import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectIsLoading } from "redux-toolkit/predictions/selectors";
import { updatePredictionAsync } from "redux-toolkit/predictions/actions";

const usePredictionVotes = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);

  const handleVote = useCallback(
    (id, currentUserId, state) => {
      const data = {
        [`votes.${currentUserId}`]: state,
      };
      dispatch(
        updatePredictionAsync({
          id,
          data,
        }),
      );
    },
    [dispatch],
  );

  return {
    isLoading,
    handleVote,
  };
};

export default usePredictionVotes;
